import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { MODAL_TYPE } from '@commons/constants';
import ModalInfo from '@components/DeliveryTypeInfo/ModalInfo';
import Tag, { TAG_TYPE } from '@components/Tag';

import { getTag } from '@shopDetails/utils/pickup';
import connect from './connect';
import messages from './messages';

function DeliveryPartnerInfo({
  isLogisticsDelivery,
  trackModalClosed,
  trackModalOpened,
  deliveryMessage,
  intl: { formatMessage },
  tagType,
  isPickup,
  isPickupFlagEnabled,
  weeklyDiscount,
  pickupDiscount,
}) {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    trackModalClosed(MODAL_TYPE.DELIVERY_TAG);
    setShowModal(false);
  };

  const open = () => {
    if (!(isPickup && isPickupFlagEnabled)) {
      setShowModal(true);
      trackModalOpened(MODAL_TYPE.DELIVERY_TAG);
    }
  };

  const { text, type, icon } = useMemo(
    () =>
      getTag({
        isPickup,
        isLogisticsDelivery,
        tagType,
        isPickupFlagEnabled,
        weeklyAmount: weeklyDiscount?.amount,
        pickupAmount: pickupDiscount?.amount,
        messages,
      }),
    [
      isPickupFlagEnabled,
      isLogisticsDelivery,
      isPickup,
      tagType,
      weeklyDiscount,
      pickupDiscount,
    ],
  );

  return (
    isLogisticsDelivery !== undefined && (
      <>
        {type === TAG_TYPE.DEALS ? (
          <Tag
            onClick={open}
            rounded
            text={formatMessage(text.message, { value: text.value })}
            type={type}
            icon={icon}
          />
        ) : (
          !isPickupFlagEnabled && (
            <Tag
              onClick={open}
              rounded
              text={formatMessage(text)}
              type={type}
              icon={icon}
            />
          )
        )}
        <ModalInfo
          showModal={showModal}
          onClose={closeModal}
          isLogisticsDelivery={isLogisticsDelivery}
          message={deliveryMessage?.typeDescription}
          formatMessage={formatMessage}
        />
      </>
    )
  );
}

DeliveryPartnerInfo.defaultProps = { tagType: TAG_TYPE.BRAND };

DeliveryPartnerInfo.propTypes = {
  isLogisticsDelivery: PropTypes.bool,
  trackModalClosed: PropTypes.func.isRequired,
  trackModalOpened: PropTypes.func.isRequired,
  deliveryMessage: PropTypes.object,
  intl: intlShape.isRequired,
  tagType: PropTypes.string,
  isPickup: PropTypes.bool,
  isPickupFlagEnabled: PropTypes.bool,
  weeklyDiscount: PropTypes.object,
  pickupDiscount: PropTypes.object,
};

export default connect(DeliveryPartnerInfo);
